import React from 'react';
import s from './s.module.less';
import { Button } from 'antd';
import ProviderStore from 'store/Provider';
import SubscriptionStore from 'store/Subscription';
import HomeStore from 'store/Home';
import OpsMessageContainer from './OpsMessageContainer';

const OpsMessagePage = () => {
    const [getSubscription] = SubscriptionStore.useStore();
    const [clickSendMsgFlag, setClickSendMsgFlag] = React.useState<{}>();

    const [getUser] = ProviderStore.useStore();
    const user = getUser('data');
    const [getHomeSore] = HomeStore.useStore();
    const homeInfo = getHomeSore('data');
    const [showTipsForSetting, setShowTipsForSetting] = React.useState(false);

    return (
        <div className={s.wrap}>
            <div className={s.header}>
                <div className={s.left}>
                    <h1>Messages</h1>
                </div>
                <div className={s.right}>
                    <Button
                        type="primary"
                        onClick={() => {
                            setClickSendMsgFlag({});
                        }}
                    >
                        Send messages
                    </Button>
                </div>
            </div>

            <div className={s.content}>
                <OpsMessageContainer clickSendMsgFlag={clickSendMsgFlag} />
            </div>
        </div>
    );
};

export default OpsMessagePage;
